import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _AdminPostMenu;
import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { and, not, or } from "truth-helpers";
import DButton from "discourse/components/d-button";
import DropdownMenu from "discourse/components/dropdown-menu";
import concatClass from "discourse/helpers/concat-class";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let AdminPostMenu = (_class = (_AdminPostMenu = class AdminPostMenu extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _initializerDefineProperty(this, "adminPostMenuButtons", _descriptor4, this);
  }
  get reviewUrl() {
    return `/review?topic_id=${this.args.data.transformedPost.id}&status=all`;
  }
  get extraButtons() {
    return this.adminPostMenuButtons.callbacks.map(callback1 => {
      return callback1(this.args.data.transformedPost);
    }).filter(Boolean);
  }
  async topicAction(actionName1) {
    await this.args.close();
    try {
      await this.args.data[actionName1]?.();
    } catch (error1) {
      // eslint-disable-next-line no-console
      console.error(`Unknown error while attempting \`${actionName1}\`:`, error1);
    }
    await this.args.data.scheduleRerender();
  }
  async extraAction(button1) {
    await this.args.close();
    await button1.action(this.args.data.post);
    await this.args.data.scheduleRerender();
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <DropdownMenu as |dropdown|>
      {{#if this.currentUser.staff}}
        <dropdown.item>
          <DButton
            @label="review.moderation_history"
            @icon="list"
            class="btn btn-transparent moderation-history"
            @href={{this.reviewUrl}}
          />
        </dropdown.item>
      {{/if}}

      {{#if (and this.currentUser.staff (not @data.transformedPost.isWhisper))}}
        <dropdown.item>
          <DButton
            @label={{if
              @data.transformedPost.isModeratorAction
              "post.controls.revert_to_regular"
              "post.controls.convert_to_moderator"
            }}
            @icon="shield-alt"
            class={{concatClass
              "btn btn-transparent toggle-post-type"
              (if @data.transformedPost.isModeratorAction "btn-success")
            }}
            @action={{fn this.topicAction "togglePostType"}}
          />
        </dropdown.item>
      {{/if}}

      {{#if @data.transformedPost.canEditStaffNotes}}
        <dropdown.item>
          <DButton
            @icon="user-shield"
            @label={{if
              @data.transformedPost.notice
              "post.controls.change_post_notice"
              "post.controls.add_post_notice"
            }}
            title="post.controls.unhide"
            class={{concatClass
              "btn btn-transparent"
              (if @data.transformedPost.notice "change-notice" "add-notice")
              (if @data.transformedPost.notice "btn-success")
            }}
            @action={{fn this.topicAction "changeNotice"}}
          />
        </dropdown.item>
      {{/if}}

      {{#if (and this.currentUser.staff @data.transformedPost.hidden)}}
        <dropdown.item>
          <DButton
            @label="post.controls.unhide"
            @icon="far-eye"
            class="btn btn-transparent unhide-post"
            @action={{fn this.topicAction "unhidePost"}}
          />
        </dropdown.item>
      {{/if}}

      {{#if
        (or
          this.currentUser.admin
          (and
            this.siteSettings.moderators_change_post_ownership
            this.currentUser.staff
          )
        )
      }}
        <dropdown.item>
          <DButton
            @label="post.controls.change_owner"
            @icon="user"
            title="post.controls.lock_post_description"
            class="btn btn-transparent change-owner"
            @action={{fn this.topicAction "changePostOwner"}}
          />
        </dropdown.item>
      {{/if}}

      {{#if (and @data.transformedPost.user_id this.currentUser.staff)}}
        {{#if this.siteSettings.enable_badges}}
          <dropdown.item>
            <DButton
              @label="post.controls.grant_badge"
              @icon="certificate"
              class="btn btn-transparent grant-badge"
              @action={{fn this.topicAction "grantBadge"}}
            />
          </dropdown.item>
        {{/if}}

        {{#if @data.transformedPost.locked}}
          <dropdown.item>
            <DButton
              @label="post.controls.unlock_post"
              @icon="unlock"
              title="post.controls.unlock_post_description"
              class={{concatClass
                "btn btn-transparent unlock-post"
                (if @data.post.locked "btn-success")
              }}
              @action={{fn this.topicAction "unlockPost"}}
            />
          </dropdown.item>
        {{else}}
          <dropdown.item>
            <DButton
              @label="post.controls.lock_post"
              @icon="lock"
              title="post.controls.lock_post_description"
              class="btn btn-transparent lock-post"
              @action={{fn this.topicAction "lockPost"}}
            />
          </dropdown.item>
        {{/if}}
      {{/if}}

      {{#if @data.transformedPost.canPermanentlyDelete}}
        <dropdown.item>
          <DButton
            @label="post.controls.permanently_delete"
            @icon="trash-alt"
            class="btn btn-transparent permanently-delete"
            @action={{fn this.topicAction "permanentlyDeletePost"}}
          />
        </dropdown.item>
      {{/if}}

      {{#if (or @data.transformedPost.canManage @data.transformedPost.canWiki)}}
        {{#if @data.transformedPost.wiki}}
          <dropdown.item>
            <DButton
              @label="post.controls.unwiki"
              @icon="far-edit"
              class={{concatClass
                "btn btn-transparent wiki wikied"
                (if @data.transformedPost.wiki "btn-success")
              }}
              @action={{fn this.topicAction "toggleWiki"}}
            />
          </dropdown.item>
        {{else}}
          <dropdown.item>
            <DButton
              @label="post.controls.wiki"
              @icon="far-edit"
              class="btn btn-transparent wiki"
              @action={{fn this.topicAction "toggleWiki"}}
            />
          </dropdown.item>
        {{/if}}
      {{/if}}

      {{#if @data.transformedPost.canPublishPage}}
        <dropdown.item>
          <DButton
            @label="post.controls.publish_page"
            @icon="file"
            class="btn btn-transparent publish-page"
            @action={{fn this.topicAction "showPagePublish"}}
          />
        </dropdown.item>
      {{/if}}

      {{#if @data.transformedPost.canManage}}
        <dropdown.item>
          <DButton
            @label="post.controls.rebake"
            @icon="sync-alt"
            class="btn btn-transparent rebuild-html"
            @action={{fn this.topicAction "rebakePost"}}
          />
        </dropdown.item>
      {{/if}}

      {{#each this.extraButtons as |button|}}
        <dropdown.item>
          <DButton
            @label={{button.label}}
            @translatedLabel={{button.translatedLabel}}
            @icon={{button.icon}}
            class={{concatClass "btn btn-transparent" button.className}}
            @action={{fn this.extraAction button}}
          />
        </dropdown.item>
      {{/each}}
    </DropdownMenu>
  
*/
{
  "id": "k1oCCY8t",
  "block": "[[[1,\"\\n    \"],[8,[32,0],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"staff\"]],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,0,\"btn btn-transparent moderation-history\"]],[[\"@label\",\"@icon\",\"@href\"],[\"review.moderation_history\",\"list\",[30,0,[\"reviewUrl\"]]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,2],[[30,0,[\"currentUser\",\"staff\"]],[28,[32,3],[[30,2,[\"transformedPost\",\"isWhisper\"]]],null]],null],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[16,0,[28,[32,4],[\"btn btn-transparent toggle-post-type\",[52,[30,2,[\"transformedPost\",\"isModeratorAction\"]],\"btn-success\"]],null]]],[[\"@label\",\"@icon\",\"@action\"],[[52,[30,2,[\"transformedPost\",\"isModeratorAction\"]],\"post.controls.revert_to_regular\",\"post.controls.convert_to_moderator\"],\"shield-alt\",[28,[32,5],[[30,0,[\"topicAction\"]],\"togglePostType\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2,[\"transformedPost\",\"canEditStaffNotes\"]],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,\"title\",\"post.controls.unhide\"],[16,0,[28,[32,4],[\"btn btn-transparent\",[52,[30,2,[\"transformedPost\",\"notice\"]],\"change-notice\",\"add-notice\"],[52,[30,2,[\"transformedPost\",\"notice\"]],\"btn-success\"]],null]]],[[\"@icon\",\"@label\",\"@action\"],[\"user-shield\",[52,[30,2,[\"transformedPost\",\"notice\"]],\"post.controls.change_post_notice\",\"post.controls.add_post_notice\"],[28,[32,5],[[30,0,[\"topicAction\"]],\"changeNotice\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,2],[[30,0,[\"currentUser\",\"staff\"]],[30,2,[\"transformedPost\",\"hidden\"]]],null],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,0,\"btn btn-transparent unhide-post\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.unhide\",\"far-eye\",[28,[32,5],[[30,0,[\"topicAction\"]],\"unhidePost\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,6],[[30,0,[\"currentUser\",\"admin\"]],[28,[32,2],[[30,0,[\"siteSettings\",\"moderators_change_post_ownership\"]],[30,0,[\"currentUser\",\"staff\"]]],null]],null],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,\"title\",\"post.controls.lock_post_description\"],[24,0,\"btn btn-transparent change-owner\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.change_owner\",\"user\",[28,[32,5],[[30,0,[\"topicAction\"]],\"changePostOwner\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,2],[[30,2,[\"transformedPost\",\"user_id\"]],[30,0,[\"currentUser\",\"staff\"]]],null],[[[41,[30,0,[\"siteSettings\",\"enable_badges\"]],[[[1,\"          \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[8,[32,1],[[24,0,\"btn btn-transparent grant-badge\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.grant_badge\",\"certificate\",[28,[32,5],[[30,0,[\"topicAction\"]],\"grantBadge\"],null]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2,[\"transformedPost\",\"locked\"]],[[[1,\"          \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[8,[32,1],[[24,\"title\",\"post.controls.unlock_post_description\"],[16,0,[28,[32,4],[\"btn btn-transparent unlock-post\",[52,[30,2,[\"post\",\"locked\"]],\"btn-success\"]],null]]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.unlock_post\",\"unlock\",[28,[32,5],[[30,0,[\"topicAction\"]],\"unlockPost\"],null]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[8,[32,1],[[24,\"title\",\"post.controls.lock_post_description\"],[24,0,\"btn btn-transparent lock-post\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.lock_post\",\"lock\",[28,[32,5],[[30,0,[\"topicAction\"]],\"lockPost\"],null]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[30,2,[\"transformedPost\",\"canPermanentlyDelete\"]],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,0,\"btn btn-transparent permanently-delete\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.permanently_delete\",\"trash-alt\",[28,[32,5],[[30,0,[\"topicAction\"]],\"permanentlyDeletePost\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,6],[[30,2,[\"transformedPost\",\"canManage\"]],[30,2,[\"transformedPost\",\"canWiki\"]]],null],[[[41,[30,2,[\"transformedPost\",\"wiki\"]],[[[1,\"          \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[8,[32,1],[[16,0,[28,[32,4],[\"btn btn-transparent wiki wikied\",[52,[30,2,[\"transformedPost\",\"wiki\"]],\"btn-success\"]],null]]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.unwiki\",\"far-edit\",[28,[32,5],[[30,0,[\"topicAction\"]],\"toggleWiki\"],null]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[8,[32,1],[[24,0,\"btn btn-transparent wiki\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.wiki\",\"far-edit\",[28,[32,5],[[30,0,[\"topicAction\"]],\"toggleWiki\"],null]]],null],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[30,2,[\"transformedPost\",\"canPublishPage\"]],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,0,\"btn btn-transparent publish-page\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.publish_page\",\"file\",[28,[32,5],[[30,0,[\"topicAction\"]],\"showPagePublish\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2,[\"transformedPost\",\"canManage\"]],[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[24,0,\"btn btn-transparent rebuild-html\"]],[[\"@label\",\"@icon\",\"@action\"],[\"post.controls.rebake\",\"sync-alt\",[28,[32,5],[[30,0,[\"topicAction\"]],\"rebakePost\"],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"extraButtons\"]]],null]],null],null,[[[1,\"        \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[32,1],[[16,0,[28,[32,4],[\"btn btn-transparent\",[30,3,[\"className\"]]],null]]],[[\"@label\",\"@translatedLabel\",\"@icon\",\"@action\"],[[30,3,[\"label\"]],[30,3,[\"translatedLabel\"]],[30,3,[\"icon\"]],[28,[32,5],[[30,0,[\"extraAction\"]],[30,3]],null]]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[3]],null],[1,\"    \"]],[1]]]]],[1,\"\\n  \"]],[\"dropdown\",\"@data\",\"button\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/admin-post-menu.js",
  "scope": () => [DropdownMenu, DButton, and, not, concatClass, fn, or],
  "isStrictMode": true
}), _AdminPostMenu), _AdminPostMenu), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "adminPostMenuButtons", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "topicAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "topicAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "extraAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "extraAction"), _class.prototype)), _class);
export { AdminPostMenu as default };